// Produktbilder für den Shop: automatisch aus dem Fachhandelskatalog extrahiert
// (Katalog-Crops + offizielle Jultec-/Kathrein-Fotos), plus eigene Bildpflege über
// die Spalte „Produktbild (Shop)“ in bestand.xlsx (dort gewinnt Ihr Eintrag).
// Fehlende Einträge = kein Bild (Platzhalter-Kachel). Neu erzeugte Katalog-Bilder:
// tools/extract_shop_images.py + tools/build_shop_from_xlsx.py
export const SHOP_IMAGES = {
  '001020': '/produkte/shop/001020.webp',
  '001045': '/produkte/shop/001045.webp',
  '001049': '/produkte/shop/001049.webp',
  '001069': '/produkte/shop/001069.webp',
  '001229': '/produkte/shop/001229.webp',
  '001230': '/produkte/shop/001230.webp',
  '001231': '/produkte/shop/001231.webp',
  '001236': '/produkte/shop/001236.webp',
  '001237': '/produkte/shop/001237.webp',
  '001238': '/produkte/shop/001238.webp',
  '001239': '/produkte/shop/001239.webp',
  '001240': '/produkte/shop/001240.webp',
  '001241': '/produkte/shop/001241.webp',
  '001242': '/produkte/shop/001242.webp',
  '001244': '/produkte/shop/001244.webp',
  '001245': '/produkte/shop/001245.webp',
  '001246': '/produkte/shop/001246.webp',
  '001247': '/produkte/shop/001247.webp',
  '001250': '/produkte/shop/001250.webp',
  '001253': '/produkte/shop/001253.webp',
  '001256': '/produkte/shop/001256.webp',
  '001257': '/produkte/shop/001257.webp',
  '001259': '/produkte/shop/001259.webp',
  '001261': '/produkte/shop/001261.webp',
  '001264': '/produkte/shop/001264.webp',
  '001265': '/produkte/shop/001265.webp',
  '001269': '/produkte/shop/001269.webp',
  '001270': '/produkte/shop/001270.webp',
  '001271': '/produkte/shop/001271.webp',
  '001272': '/produkte/shop/001272.webp',
  '001273': '/produkte/shop/001273.webp',
  '001274': '/produkte/shop/001274.webp',
  '001276': '/produkte/shop/001276.webp',
  '001277': '/produkte/shop/001277.webp',
  '001278': '/produkte/shop/001278.webp',
  '001283': '/produkte/shop/001283.webp',
  '001285': '/produkte/shop/001285.webp',
  '002067': '/produkte/shop/002067.webp',
  '002068': '/produkte/shop/002068.webp',
  '002079': '/produkte/shop/002079.webp',
  '005005': '/produkte/shop/005005.webp',
  '005010': '/produkte/shop/005010.webp',
  '005014': '/produkte/shop/005014.webp',
  '006003': '/produkte/shop/006003.webp',
  '006007': '/produkte/shop/006007.webp',
  '006010': '/produkte/shop/006010.webp',
  '006013': '/produkte/shop/006013.webp',
  '006015': '/produkte/shop/006015.webp',
  '006016': '/produkte/shop/006016.webp',
  '006017': '/produkte/shop/006017.webp',
  '006018': '/produkte/shop/006018.webp',
  '006019': '/produkte/shop/006019.webp',
  '006025': '/produkte/shop/006025.webp',
  '006030': '/produkte/shop/006030.webp',
  '007009': '/produkte/shop/007009.webp',
  '007013': '/produkte/shop/007013.webp',
  '008094': '/produkte/shop/008094.webp',
  '010005': '/produkte/shop/010005.webp',
  '011003': '/produkte/shop/011003.webp',
  '012005': '/produkte/shop/012005.webp',
  '012006': '/produkte/shop/012006.webp',
  '012007': '/produkte/shop/012007.webp',
  '012008': '/produkte/shop/012008.webp',
  '012009': '/produkte/shop/012009.webp',
  '012012': '/produkte/shop/012012.webp',
  '013001': '/produkte/shop/013001.webp',
  '013002': '/produkte/shop/013002.webp',
  '013003': '/produkte/shop/013003.webp',
  '013004': '/produkte/shop/013004.webp',
  '013005': '/produkte/shop/013005.webp',
  '013016': '/produkte/shop/013016.webp',
  '013017': '/produkte/shop/013017.webp',
  '014004': '/produkte/shop/014004.webp',
  '014007': '/produkte/shop/014007.webp',
  '014010': '/produkte/shop/014010.webp',
  '014011': '/produkte/shop/014011.webp',
  '014012': '/produkte/shop/014012.webp',
  '014066': '/produkte/shop/014066.webp',
  '014067': '/produkte/shop/014067.webp',
  '014068': '/produkte/shop/014068.webp',
  '014069': '/produkte/shop/014069.webp',
  '014072': '/produkte/shop/014072.webp',
  '014075': '/produkte/shop/014075.webp',
  '015001': '/produkte/shop/015001.webp',
  '015002': '/produkte/shop/015002.webp',
  '015003': '/produkte/shop/015003.webp',
  '015004': '/produkte/shop/015004.webp',
  '015005': '/produkte/shop/015005.webp',
  '015024': '/produkte/shop/015024.webp',
  '015028': '/produkte/shop/015028.webp',
  '016003': '/produkte/shop/016003.webp',
  '018001': '/produkte/shop/018001.webp',
  '018002': '/produkte/shop/018002.webp',
  '018003': '/produkte/shop/018003.webp',
  '018006': '/produkte/shop/018006.webp',
  '018007': '/produkte/shop/018007.webp',
  '018008': '/produkte/shop/018008.webp',
  '018009': '/produkte/shop/018009.webp',
  '018010': '/produkte/shop/018010.webp',
  '018011': '/produkte/shop/018011.webp',
  '018014': '/produkte/shop/018014.webp',
  '018015': '/produkte/shop/018015.webp',
  '018016': '/produkte/shop/018016.webp',
  '018017': '/produkte/shop/018017.webp',
  '018018': '/produkte/shop/018018.webp',
  '018019': '/produkte/shop/018019.webp',
  '018024': '/produkte/shop/018024.webp',
  '018029': '/produkte/shop/018029.webp',
  '018031': '/produkte/shop/018031.webp',
  '018032': '/produkte/shop/018032.webp',
  '018036': '/produkte/shop/018036.webp',
  '018038': '/produkte/shop/018038.webp',
  '018039': '/produkte/shop/018039.webp',
  '019001': '/produkte/shop/019001.webp',
  '019006': '/produkte/shop/019006.webp',
  '019009': '/produkte/shop/019009.webp',
  '019010': '/produkte/shop/019010.webp',
  '019011': '/produkte/shop/019011.webp',
  '019021': '/produkte/shop/019021.webp',
  '019022': '/produkte/shop/019022.webp',
  '021059': '/produkte/shop/021059.webp',
  '021060': '/produkte/shop/021060.webp',
  '021079': '/produkte/shop/021079.webp',
  '021080': '/produkte/shop/021080.webp',
  '021081': '/produkte/shop/021081.webp',
  '021082': '/produkte/shop/021082.webp',
  '023001': '/produkte/shop/023001.webp',
  '023002': '/produkte/shop/023002.webp',
  '023003': '/produkte/shop/023003.webp',
  '023004': '/produkte/shop/023004.webp',
  '023005': '/produkte/shop/023005.webp',
  '023006': '/produkte/shop/023006.webp',
  '023007': '/produkte/shop/023007.webp',
  '023008': '/produkte/shop/023008.webp',
  '023009': '/produkte/shop/023009.webp',
  '023010': '/produkte/shop/023010.webp',
  '023011': '/produkte/shop/023011.webp',
  '023012': '/produkte/shop/023012.webp',
  '023015': '/produkte/shop/023015.webp',
  '023018': '/produkte/shop/023018.webp',
  '023020': '/produkte/shop/023020.webp',
  '023021': '/produkte/shop/023021.webp',
  '023022': '/produkte/shop/023022.webp',
  '023026': '/produkte/shop/023026.webp',
  '023027': '/produkte/shop/023027.webp',
  '023034': '/produkte/shop/023034.webp',
  '024001': '/produkte/shop/024001.webp',
  '024002': '/produkte/shop/024002.webp',
  '024003': '/produkte/shop/024003.webp',
  '024005': '/produkte/shop/024005.webp',
  '024008': '/produkte/shop/024008.webp',
  '024010': '/produkte/shop/024010.webp',
  '024015': '/produkte/shop/024015.webp',
  '024016': '/produkte/shop/024016.webp',
  '024017': '/produkte/shop/024017.webp',
  '024018': '/produkte/shop/024018.webp',
  '024019': '/produkte/shop/024019.webp',
  '024020': '/produkte/shop/024020.webp',
  '024030': '/produkte/shop/024030.webp',
  '024035': '/produkte/shop/024035.webp',
  '027044': '/produkte/shop/027044.webp',
  '027045': '/produkte/shop/027045.webp',
  '035003': '/produkte/shop/035003.webp',
  '035004': '/produkte/shop/035004.webp',
  '036002': '/produkte/shop/036002.webp',
  '036006': '/produkte/shop/036006.webp',
  '036017': '/produkte/shop/036017.webp',
  '036040': '/produkte/shop/036040.webp',
  '036041': '/produkte/shop/036041.webp',
  '036042': '/produkte/shop/036042.webp',
  '036043': '/produkte/shop/036043.webp',
  '036044': '/produkte/shop/036044.webp',
  '036045': '/produkte/shop/036045.webp',
  '036046': '/produkte/shop/036046.webp',
  '036047': '/produkte/shop/036047.webp',
  '036048': '/produkte/shop/036048.webp',
  '036049': '/produkte/shop/036049.webp',
  '036050': '/produkte/shop/036050.webp',
  '036051': '/produkte/shop/036051.webp',
  '036053': '/produkte/shop/036053.webp',
  '036054': '/produkte/shop/036054.webp',
  '036056': '/produkte/shop/036056.webp',
  '036058': '/produkte/shop/036058.webp',
  '036059': '/produkte/shop/036059.webp',
  '036060': '/produkte/shop/036060.webp',
  '036061': '/produkte/shop/036061.webp',
  '036062': '/produkte/shop/036062.webp',
  '036063': '/produkte/shop/036063.webp',
  '036067': '/produkte/shop/036067.webp',
  '036068': '/produkte/shop/036068.webp',
  '036069': '/produkte/shop/036069.webp',
  '036079': '/produkte/shop/036079.webp',
  '036080': '/produkte/shop/036080.webp',
  '036081': '/produkte/shop/036081.webp',
  '036083': '/produkte/shop/036083.webp',
  '036085': '/produkte/shop/036085.webp',
  '036090': '/produkte/shop/036090.webp',
  '039041': '/produkte/shop/039041.webp',
  '042001': '/produkte/shop/042001.webp',
  '042002': '/produkte/shop/042002.webp',
  '042004': '/produkte/shop/042004.webp',
  '042005': '/produkte/shop/042005.webp',
  '042007': '/produkte/shop/042007.webp',
  '042009': '/produkte/shop/042009.webp',
  '042010': '/produkte/shop/042010.webp',
  '042011': '/produkte/shop/042011.webp',
  '042012': '/produkte/shop/042012.webp',
  '042014': '/produkte/shop/042014.webp',
  '042018': '/produkte/shop/042018.webp',
  '047001': '/produkte/shop/047001.webp',
  '047002': '/produkte/shop/047002.webp',
  '047003': '/produkte/shop/047003.webp',
  '047004': '/produkte/shop/047004.webp',
  '047008': '/produkte/shop/047008.webp',
  '047011': '/produkte/shop/047011.webp',
  '047013': '/produkte/shop/047013.webp',
  '047015': '/produkte/shop/047015.webp',
  '051013': '/produkte/shop/051013.webp',
  '054002': '/produkte/shop/054002.webp',
  '054003': '/produkte/shop/054003.webp',
  '054008': '/produkte/shop/054008.webp',
  '055001': '/produkte/shop/055001.webp',
  '055006': '/produkte/shop/055006.webp',
  '055007': '/produkte/shop/055007.webp',
  '055017': '/produkte/shop/055017.webp',
  '055018': '/produkte/shop/055018.webp',
  '055019': '/produkte/shop/055019.webp',
  '055020': '/produkte/shop/055020.webp',
  '055021': '/produkte/shop/055021.webp',
  '055022': '/produkte/shop/055022.webp',
  '055023': '/produkte/shop/055023.webp',
  '055029': '/produkte/shop/055029.webp',
  '055031': '/produkte/shop/055031.webp',
  '055033': '/produkte/shop/055033.webp',
  '055035': '/produkte/shop/055035.webp',
  '055036': '/produkte/shop/055036.webp',
  '056001': '/produkte/shop/056001.webp',
  '056002': '/produkte/shop/056002.webp',
  '056004': '/produkte/shop/056004.webp',
  '059001': '/produkte/shop/059001.webp',
  '059029': '/produkte/shop/059029.webp',
  '060002': '/produkte/shop/060002.webp',
  '060007': '/produkte/shop/060007.webp',
  '060009': '/produkte/shop/060009.webp',
  '060010': '/produkte/shop/060010.webp',
  '060017': '/produkte/shop/060017.webp',
  '060023': '/produkte/shop/060023.webp',
  '061001': '/produkte/shop/061001.webp',
  '061002': '/produkte/shop/061002.webp',
  '061003': '/produkte/shop/061003.webp',
  '062001': '/produkte/shop/062001.webp',
  '062003': '/produkte/shop/062003.webp',
  '062004': '/produkte/shop/062004.webp',
  '063012': '/produkte/shop/063012.webp',
  '066004': '/produkte/shop/066004.webp',
  '066005': '/produkte/shop/066005.webp',
  '066007': '/produkte/shop/066007.webp',
  '066009': '/produkte/shop/066009.webp',
  '066010': '/produkte/shop/066010.webp',
  '067001': '/produkte/shop/067001.webp',
  '068001': '/produkte/shop/068001.webp',
  '068006': '/produkte/shop/068006.webp',
  '071006': '/produkte/shop/071006.webp',
  '086102': '/produkte/shop/086102.webp',
  '086103': '/produkte/shop/086103.webp',
  '086104': '/produkte/shop/086104.webp',
  '086106': '/produkte/shop/086106.webp',
  '086107': '/produkte/shop/086107.webp',
  '087006': '/produkte/shop/087006.webp',
  '087007': '/produkte/shop/087007.webp',
  '087014': '/produkte/shop/087014.webp',
  '087020': '/produkte/shop/087020.webp',
  '087021': '/produkte/shop/087021.webp',
  '087027': '/produkte/shop/087027.webp',
  '090001': '/produkte/shop/090001.webp',
  '091003': '/produkte/shop/091003.webp',
  '093048': '/produkte/shop/093048.webp',
  '093049': '/produkte/shop/093049.webp',
  '093053': '/produkte/shop/093053.webp',
  '093054': '/produkte/shop/093054.webp',
  '093055': '/produkte/shop/093055.webp',
  '099024': '/produkte/shop/099024.webp',
  '099062': '/produkte/shop/099062.webp',
  '099063': '/produkte/shop/099063.webp',
  '099078': '/produkte/shop/099078.webp',
  '099092': '/produkte/shop/099092.webp',
  '100005': '/produkte/shop/100005.webp',
  '100007': '/produkte/shop/100007.webp',
  '100008': '/produkte/shop/100008.webp',
  '100020': '/produkte/shop/100020.webp',
  '100032': '/produkte/shop/100032.webp',
  '100035': '/produkte/shop/100035.webp',
  '100036': '/produkte/shop/100036.webp',
  '102007': '/produkte/shop/102007.webp',
  '102010': '/produkte/shop/102010.webp',
  '102011': '/produkte/shop/102011.webp',
  '102017': '/produkte/shop/102017.webp',
  '102021': '/produkte/shop/102021.webp',
  '104001': '/produkte/shop/104001.webp',
  '104002': '/produkte/shop/104002.webp',
  '104003': '/produkte/shop/104003.webp',
  '104009': '/produkte/shop/104009.webp',
  '108000': '/produkte/shop/108000.webp',
  '108001': '/produkte/shop/108001.webp',
  '108005': '/produkte/shop/108005.webp',
  '108006': '/produkte/shop/108006.webp',
  '108007': '/produkte/shop/108007.webp',
  '108008': '/produkte/shop/108008.webp',
  '108009': '/produkte/shop/108009.webp',
  '108010': '/produkte/shop/108010.webp',
  '108011': '/produkte/shop/108011.webp',
  '110013': '/produkte/shop/110013.webp',
  '113002': '/produkte/shop/113002.webp',
  '115001': '/produkte/shop/115001.webp',
  '128005': '/produkte/shop/128005.webp',
  '128006': '/produkte/shop/128006.webp',
  '132004': '/produkte/shop/132004.webp',
  '132005': '/produkte/shop/132005.webp',
  '132006': '/produkte/shop/132006.webp',
  '132009': '/produkte/shop/132009.webp',
  '132010': '/produkte/shop/132010.webp',
  '132012': '/produkte/shop/132012.webp',
  '132013': '/produkte/shop/132013.webp',
  '138001': '/produkte/shop/138001.webp',
  '138002': '/produkte/shop/138002.webp',
  '142001': '/produkte/shop/142001.webp',
  '145001': '/produkte/shop/145001.webp',
  '145002': '/produkte/shop/145002.webp',
  '145003': '/produkte/shop/145003.webp',
  '145004': '/produkte/shop/145004.webp',
  '145005': '/produkte/shop/145005.webp',
  '145006': '/produkte/shop/145006.webp',
  '146033': '/produkte/shop/146033.webp',
  '166005': '/produkte/shop/166005.webp',
  '166009': '/produkte/shop/166009.webp',
  '210004': '/produkte/shop/210004.webp',
  '225000': '/produkte/shop/225000.webp',
  '225002': '/produkte/shop/225002.webp',
  '225006': '/produkte/shop/225006.webp',
  '230049': '/produkte/shop/230049.webp',
  '230057': '/produkte/shop/230057.webp',
  '230060': '/produkte/shop/230060.webp',
  '230063': '/produkte/shop/230063.webp',
  '231002': '/produkte/shop/231002.webp',
  '231003': '/produkte/shop/231003.webp',
  '237000': '/produkte/shop/237000.webp',
  '237002': '/produkte/shop/237002.webp',
  '237004': '/produkte/shop/237004.webp',
  '237012': '/produkte/shop/237012.webp',
  '237013': '/produkte/shop/237013.webp',
  '237025': '/produkte/shop/237025.webp',
  '237031': '/produkte/shop/237031.webp',
  '237033': '/produkte/shop/237033.webp',
  '237043': '/produkte/shop/237043.webp',
  '237044': '/produkte/shop/237044.webp',
  '237046': '/produkte/shop/237046.webp',
  '237047': '/produkte/shop/237047.webp',
  '237051': '/produkte/shop/237051.webp',
  '237052': '/produkte/shop/237052.webp',
  '237055': '/produkte/shop/237055.webp',
  '237056': '/produkte/shop/237056.webp',
  '237057': '/produkte/shop/237057.webp',
  '237058': '/produkte/shop/237058.webp',
  '237059': '/produkte/shop/237059.webp',
  '237060': '/produkte/shop/237060.webp',
  '237061': '/produkte/shop/237061.webp',
  '237062': '/produkte/shop/237062.webp',
  '237063': '/produkte/shop/237063.webp',
  '237064': '/produkte/shop/237064.webp',
  '237065': '/produkte/shop/237065.webp',
  '237066': '/produkte/shop/237066.webp',
  '237067': '/produkte/shop/237067.webp',
  '237078': '/produkte/shop/237078.webp',
  '237082': '/produkte/shop/237082.webp',
  '237083': '/produkte/shop/237083.webp',
  '237084': '/produkte/shop/237084.webp',
  '237086': '/produkte/shop/237086.webp',
  '237090': '/produkte/shop/237090.webp',
  '237091': '/produkte/shop/237091.webp',
  '237092': '/produkte/shop/237092.webp',
  '237093': '/produkte/shop/237093.webp',
  '237094': '/produkte/shop/237094.webp',
  '237095': '/produkte/shop/237095.webp',
  '237098': '/produkte/shop/237098.webp',
  '237101': '/produkte/shop/237101.webp',
  '237102': '/produkte/shop/237102.webp',
  '237104': '/produkte/shop/237104.webp',
  '237105': '/produkte/shop/237105.webp',
  '237108': '/produkte/shop/237108.webp',
  '237109': '/produkte/shop/237109.webp',
  '237110': '/produkte/shop/237110.webp',
  '237113': '/produkte/shop/237113.webp'
};
